module.exports = __webpack_public_path__ + "media/images/mailer/logo_white-2fc747756051dfa98cd611cf55207567.png";